import { useQuery, UseQueryOptions } from '@tanstack/react-query';

import { getProjectSubprojects } from '@/features/projects/shared/api/get-project-subprojects';
import { ProjectWithContractors } from '@/shared/types/api';

type Props = {
  projectId: number;
  queryProps?: UseQueryOptions<
    ProjectWithContractors[],
    unknown,
    ProjectWithContractors[]
  >;
};

export function getProjectSubprojectsQueryKey({
  projectId,
}: {
  projectId: number;
}) {
  return ['projectSubprojects', projectId];
}

export const useProjectSubprojects = ({ projectId, queryProps }: Props) => {
  return useQuery({
    ...queryProps,
    queryKey: getProjectSubprojectsQueryKey({ projectId }),
    queryFn: () => getProjectSubprojects({ projectId }),
  });
};
